import { render, staticRenderFns } from "./BotActionButton.vue?vue&type=template&id=3edef852"
import script from "./BotActionButton.vue?vue&type=script&lang=js"
export * from "./BotActionButton.vue?vue&type=script&lang=js"
import style0 from "./BotActionButton.vue?vue&type=style&index=0&id=3edef852&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports